import * as React from 'react';
import cx from 'classnames';
import onClickOutside from "react-onclickoutside";
import Button from "~/common/elements/mobile/Button";
import { buttonSize, buttonStyle } from "~/common/elements/mobile/consts";


interface IProps {
  options: any;
}

interface IState {
  visible: boolean;
}


class DropButton extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  toggleDropDown = (e) => {
    e.stopPropagation();
    this.setState({
      visible: !this.state.visible,
    });
  };

  handleClickOutside = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { options } = this.props;

    const mainClassName = "btn btn--md btn--ir btn--tert drop__anch btn--prim";
    const itemClassName = "drop__down__item";

    let buttons = [...options];

    if (buttons.length == 1) {
      buttons = buttons.map(o =>
        (<Button
          key={o.title}
          title={o.title}
          buttonStyle={`${buttonStyle.PRIM} ${buttonStyle.OUTL}`}
          buttonSize={buttonSize.MD}
          onClick={o.onClick}
        />)
      );
    } else {
      buttons = buttons.map((o, index) =>
        (<button key={o.title} className={index == 0 ? mainClassName : itemClassName}
                onClick={o.onClick}>
          {o.title}
          {index == 0 ? <span className="i i-arw-b" onClick={this.toggleDropDown}></span> : ''}
        </button>));
    }

    const mainOption = buttons.shift();

    const cn = cx('drop__cont drop', {
      'drop--active': this.state.visible,
    });

    return (
      <div className={cn}>
        {mainOption}
        {!!buttons.length &&
        <div className="drop__down">
          <div className="drop__inn">
            {buttons}
          </div>
        </div>}
      </div>
    );
  }
};

export default onClickOutside(DropButton);
